import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { myProfile } from 'Redux/user-profile/selectors';

import { TextTitle, TextSubTitle, TextDescription } from '../Components/TextContent';
import { ContentWrapper, CardWrapper } from '../Components/WrapperContent';

const UserSession = ({ userId, learnId }) => {
  return (
    <>
      {userId && learnId && (
        <>
          <TextTitle mt={8}>เซสชันของผู้ใช้</TextTitle>
          <ContentWrapper>
            <CardWrapper>
              <TextSubTitle>User ID</TextSubTitle>
              <TextDescription>{userId}</TextDescription>
            </CardWrapper>
            <CardWrapper>
              <TextSubTitle>Learn ID</TextSubTitle>
              <TextDescription>{learnId}</TextDescription>
            </CardWrapper>
          </ContentWrapper>
        </>
      )}
    </>
  );
};

UserSession.propTypes = {
  userId: PropTypes.string,
  learnId: PropTypes.string,
};

export default connect(
  (state) => ({ userId: myProfile(state)?.id, learnId: myProfile(state)?.additional6 }),
  {}
)(UserSession);
